<div class="d__flex header">
  <div>
    <h6 class="m-0 heading__">Seller Form Review</h6>
  </div>
  <ion-icon (click)="close_modal()" class="mouse" name="close-outline"></ion-icon>
</div>
<div class="scroll">


  <div class="box">
    <h3 class="m-0 bold_name head__">Perosnal Details</h3>
    <h6 class="m-0 medium_name line_1">First Name : <span class="line_2 ">{{form_value.first_name}}</span></h6>
    <h6 class="m-0 medium_name line_1">Last Name : <span class="line_2 ">{{form_value.last_name}}</span></h6>
    <h6 class="m-0 medium_name line_1">Phone Number : <span class="line_2 ">{{form_value.phone}}</span></h6>
    <h6 class="m-0 medium_name line_1">Alternative Phone Number : <span
        class="line_2 ">{{form_value.alternate_mobile_number}}</span></h6>
    <h6 class="m-0 medium_name line_1">Email : <span class="line_2 ">{{form_value.email}}</span></h6>
    <h6 class="m-0 medium_name line_1">Address Map : <span class="line_2 ">{{form_value.address_map}}</span></h6>
    <h6 class="m-0 medium_name line_1">Address : <span class="line_2 ">{{form_value.address}}</span></h6>
    <h6 class="m-0 medium_name line_1">Country : <span class="line_2 ">{{form_value.country}}</span></h6>
    <h6 class="m-0 medium_name line_1">State : <span class="line_2 ">{{form_value.state}}</span></h6>
    <h6 class="m-0 medium_name line_1">City : <span class="line_2 ">{{form_value.city}}</span></h6>
    <h6 class="m-0 medium_name line_1">Zipcode : <span class="line_2 ">{{form_value.zipcode}}</span></h6>
    <h6 class="m-0 medium_name line_1">Latitude : <span class="line_2 ">{{form_value.latitude}}</span></h6>
    <h6 class="m-0 medium_name line_1">Longtitude : <span class="line_2 ">{{form_value.longitude}}</span></h6>

  </div>

  <div class="box">
    <h3 class="m-0 bold_name head__">Business Details</h3>
    <h6 class="m-0 medium_name line_1">Business Type : <span class="line_2 ">{{form_value.business_type}}</span></h6>
    <h6 class="m-0 medium_name line_1">Restaurant Name : <span class="line_2 ">{{form_value.restaurant_name}}</span>
    </h6>
    <h6 class="m-0 medium_name line_1">Business Address Map : <span
        class="line_2 ">{{form_value.business_address_map}}</span></h6>
    <h6 class="m-0 medium_name line_1">Business Adress : <span class="line_2 ">{{form_value.business_address}}</span>
    </h6>
    <h6 class="m-0 medium_name line_1">Landmark : <span class="line_2 ">{{form_value.business_landmark}}</span></h6>
    <h6 class="m-0 medium_name line_1">Country : <span class="line_2 ">{{form_value.business_country}}</span></h6>
    <h6 class="m-0 medium_name line_1">State : <span class="line_2 ">{{form_value.business_state}}</span></h6>
    <h6 class="m-0 medium_name line_1">City : <span class="line_2 ">{{form_value.business_city}}</span></h6>
    <h6 class="m-0 medium_name line_1">Zipcode : <span class="line_2 ">{{form_value.business_zip_code}}</span></h6>
    <h6 class="m-0 medium_name line_1">Latitude : <span class="line_2 ">{{form_value.business_latitude}}</span></h6>
    <h6 class="m-0 medium_name line_1">Longtitude : <span class="line_2 ">{{form_value.business_longitude}}</span></h6>
    <h6 class="m-0 medium_name line_1">GSTIN : <span class="line_2 ">{{form_value.gstin}}</span></h6>
    <h6 class="m-0 medium_name line_1">Bank Name : <span class="line_2 ">{{form_value.bank_name}}</span></h6>
    <h6 class="m-0 medium_name line_1">Bank IFSC : <span class="line_2 ">{{form_value.bank_ifsc}}</span></h6>
    <h6 class="m-0 medium_name line_1">Branch Name : <span class="line_2 ">{{form_value.branch_name}}</span></h6>


  </div>
  <div class="d__flex padding box">

    <div *ngIf="form_value && form_value.business_identity_proof && form_value.business_identity_proof.length != 0">
      <h5>Business Identity Proof</h5>
      <div class="d__flex gap-10 wrap">
        <div *ngFor="let item of form_value.business_identity_proof" class="d__flex browser flex">
          <div class="mouse d__flex name">
            <!-- <span>Browse</span> -->
            <img [src]="db.attach_filter(item.identity_proof_attachment,'_green')">
            <!-- <ion-icon name="chevron-down-outline"></ion-icon> -->
          </div>
          <div class="d__flex value_div width">

            <a class="m-0 mouse  webkit-text" [style.--line]="1">{{item.identity_proof}}</a>
            <a class="value_ mouse"
              (click)="this.db.preview_image(db.product_img(item.identity_proof_attachment))">{{item.identity_proof_attachment}}</a>
          </div>
        </div>

      </div>

    </div>

  </div>

  <div class="d__flex padding box">

    <div *ngIf="form_value && form_value.business_address_proof && form_value.business_address_proof.length != 0">
      <h5>Business Address Proof</h5>
      <div class="d__flex gap-10 wrap">
        <div *ngFor="let item of form_value.business_address_proof" class="d__flex browser flex">
          <div class="mouse d__flex name ">
            <!-- <span>Browse</span> -->
            <img [src]="db.attach_filter(item.address_proof_attachment,'_green')">
            <!-- <ion-icon name="chevron-down-outline"></ion-icon> -->
          </div>
          <div class="d__flex value_div width">

            <a class="m-0 mouse  webkit-text" [style.--line]="1">{{item.address_proof}}</a>
            <a class="value_ mouse"
              (click)="this.db.preview_image(db.product_img(item.address_proof_attachment))">{{item.address_proof_attachment}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="d__flex padding box">

    <div *ngIf="form_value && form_value.business_documents && form_value.business_documents.length != 0">
      <h5>Business Documents</h5>
      <div class="d__flex gap-10 wrap">
        <div *ngFor="let item of form_value.business_documents" class="d__flex browser flex">
          <div class="mouse d__flex name">
            <!-- <span>Browse</span> -->
            <img [src]="db.attach_filter(item.kyc_doc_attachment,'_green')">
            <!-- <ion-icon name="chevron-down-outline"></ion-icon> -->
          </div>
          <div class="d__flex value_div width">

            <a class="m-0 mouse  webkit-text" [style.--line]="1">{{item.business_kycdocument}}</a>
            <a class="value_ mouse"
              (click)="this.db.preview_image(db.product_img(item.kyc_doc_attachment))">{{item.kyc_doc_attachment}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ion-footer >
    <ion-toolbar>
      <ion-button fill="clear" (click)="close_modal()" expand="full" class="save" class="save" >Submit</ion-button>
    </ion-toolbar>
  </ion-footer>
</div>
